import mountDefaultValues from './mountDefaultValues'

const fantasyDpos = {
  mountDefaultValues,
}

export default fantasyDpos
